<template>
  <div class="my-15 flex justify-center items-center relative">
    <div
      class="w-full h-48 bg-black bg-cover bg-center relative before:absolute before:inset-0 before:bg-black before:opacity-20 before:z-0 max-w"
      :style="{
        backgroundImage: `url(${seoData.image})`,
      }"
    />
    <TTitle
      color="text-white"
      tag="h2"
      size="3xl"
      classes="max-w-4/5 text-shadow-lg text-center text-ellipsis  line-clamp-2 mx-8 absolute"
    >
      {{ seoData.title }}
    </TTitle>
  </div>

  <TContainer>
    <TProse>
      <div v-html="seoData.description"></div>
    </TProse>
  </TContainer>
</template>

<script setup lang="ts">
interface SeoData {
  image: string
  title: string
  description: string
}

defineProps<{
  seoData: SeoData
}>()
</script>
